import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ApplicationClientCommonModule, CommonLayoutModule, CommonTranslationModule, CommonUIModule, MasterDetailModule } from '@sdbn/common';
import { StationDetailsComponent } from './component/station-details/station-details.component';
import { StationComponent } from './component/station.component';


@NgModule({
  declarations: [
    StationComponent,
    StationDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatSelectModule,
    MatFormFieldModule,
    DragDropModule,
    MatInputModule,
    MatCheckboxModule
  ]
})
export class StationModule { }

